export enum EFundingBannerConsultingStep {
  FORM = 'FORM',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  REGISTRATION = 'REGISTRATION',
  LOGIN = 'LOGIN',
  COMMUNICATION_METHOD = 'COMMUNICATION_METHOD',
}
